import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Check from '@material-ui/icons/Check';
import SettingsIcon from '@material-ui/icons/Settings';
import InfoIcon from '@material-ui/icons/Info';
import SendIcon from '@material-ui/icons/Send';
import StepConnector from '@material-ui/core/StepConnector';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Step1 from '../Step1';
import Step2 from '../Step2';
import Step3 from '../Step3';
import OrderSent from '../OrderSent';
import { toastSuccessHelper } from 'redux/sagas/financial-model/scenarios.sagas';

export const currencyOptions = [
  { value: 1, label: 'Euros (€)', color: '#00B8D9' },
  { value: 2, label: 'Dollars ($)', color: '#0052CC' }
];

export const orderOptions = [
  { value: 1, label: '% of capital raise', color: '#00B8D9' },
  { value: 2, label: 'Your investment in €', color: '#0052CC' }
];

// const QontoConnector = withStyles({
//   alternativeLabel: {
//     top: 10,
//     left: 'calc(-50% + 16px)',
//     right: 'calc(50% + 16px)'
//   },
//   active: {
//     '& $line': {
//       borderColor: '#784af4'
//     }
//   },
//   completed: {
//     '& $line': {
//       borderColor: '#784af4'
//     }
//   },
//   line: {
//     borderColor: '#eaeaf0',
//     borderTopWidth: 3,
//     borderRadius: 1
//   }
// })(StepConnector);

const useQontoStepIconStyles = makeStyles({
  root: {
    color: '#eaeaf0',
    display: 'flex',
    height: 22,
    alignItems: 'center'
  },
  active: {
    color: '#784af4'
  },
  circle: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: 'currentColor'
  },
  completed: {
    color: '#784af4',
    zIndex: 1,
    fontSize: 18
  }
});

function QontoStepIcon(props) {
  const classes = useQontoStepIconStyles();
  const { active, completed } = props;

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active
      })}>
      {completed ? (
        <Check className={classes.completed} />
      ) : (
        <div className={classes.circle} />
      )}
    </div>
  );
}

QontoStepIcon.propTypes = {
  /**
   * Whether this step is active.
   */
  active: PropTypes.bool.isRequired,
  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: PropTypes.bool.isRequired
};

const ColorlibConnector = withStyles({
  alternativeLabel: {
    top: 22
  },
  active: {
    '& $line': {
      backgroundImage:
        'linear-gradient( 95deg,#e0e0e0 0%,#036aed 50%,#002380 100%)'
    }
  },
  completed: {
    '& $line': {
      backgroundImage:
        'linear-gradient( 95deg,#122fb3 0%,#036aed 50%,#002380 100%)'
    }
  },
  line: {
    height: 3,
    border: 0,
    backgroundColor: '#eaeaf0',
    borderRadius: 1
  }
})(StepConnector);

const useColorlibStepIconStyles = makeStyles({
  root: {
    backgroundColor: '#ccc',
    zIndex: 1,
    color: '#fff',
    width: 50,
    height: 50,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center'
  },
  active: {
    backgroundImage:
      'linear-gradient( 136deg, #036aed 0%, #0e4ead 50%, #2684ff 100%)',
    boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)'
  },
  completed: {
    backgroundImage:
      'linear-gradient( 136deg, #036aed 0%, #002380 50%, #002380 100%)'
  }
});

function ColorlibStepIcon({ icon, active, completed }) {
  const classes = useColorlibStepIconStyles();

  const icons = {
    1: <SettingsIcon />,
    2: <InfoIcon />,
    3: <SendIcon />
  };

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed
      })}>
      {icons[String(icon)]}
    </div>
  );
}

ColorlibStepIcon.propTypes = {
  /**
   * Whether this step is active.
   */
  active: PropTypes.bool.isRequired,
  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: PropTypes.bool.isRequired,
  /**
   * The label displayed in the step icon.
   */
  icon: PropTypes.node.isRequired
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%'
  },
  buttonContainer: {
    margin: '25px 15px',
    textAlign: 'right'
  },
  button: {
    marginRight: theme.spacing(1),
    minWidth: 115
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  stepper: {
    background: 'transparent'
  },
  stepperLabel: {
    '& .MuiStepLabel-label.MuiStepLabel-active': {
      fontSize: '17px !important',
      fontWeight: 'bold !important',
      color: '#002380 !important'
    }
  }
}));

function getSteps() {
  return ['Select order settings', 'Order informations', 'Send order'];
}

const StepperComponent = ({ sendOrder, saveOrder }) => {
  const classes = useStyles();
  const [loading, setIsLoading] = useState(false);
  const [orderValue, setOrderValue] = useState(null);
  const [valuation, setValuation] = useState(null);
  const [sharesNumber, setSharesNumber] = useState(null);
  const [valuationPercent, setValuationPercent] = useState(null);
  const [sharePrice, setSharePrice] = useState(null);
  const [currency, setCurrency] = useState(null);
  const [order, setOrder] = useState(null);
  const [dealSize, setDealSize] = useState(1000000000);
  const [sharesNum, setSharesNum] = useState(100000000);
  const [unitPrice, setUnitprice] = useState(10);
  const [activeStep, setActiveStep] = useState(0);
  const steps = getSteps();

  const renderStep = (step) => {
    switch (step) {
      case 0:
        return (
          <Step1
            order={order}
            currency={currency}
            currencyOptions={currencyOptions}
            orderOptions={orderOptions}
            setCurrency={(e) => setCurrency(e)}
            setOrder={(e) => setOrder(e)}
          />
        );
      case 1:
        return (
          <Step2
            order={order}
            currency={currency}
            valuation={valuation}
            setValuation={(e) => setValuation(e.target.value)}
            orderValue={orderValue}
            setOrderValue={(e) => setOrderValue(e.target.value)}
            dealSize={dealSize}
            sharesNumber={sharesNumber}
            setSharesNumber={(e) => setSharesNumber(e.target.value)}
            sharePrice={sharePrice}
            setSharePrice={(e) => setSharePrice(e.target.value)}
            valuationPercent={valuationPercent}
            setValuationPercent={(e) => setValuationPercent(e.target.value)}
            sharesNum={sharesNum}
            unitPrice={unitPrice}
          />
        );
      case 2:
        return (
          <Step3
            loading={loading}
            currency={currency}
            order={order}
            valuation={valuation}
            orderValue={orderValue}
            sharesNumber={sharesNumber}
            sharePrice={sharePrice}
            valuationPercent={valuationPercent}
            dealSize={dealSize}
            sharesNum={sharesNum}
            unitPrice={unitPrice}
          />
        );
      default:
        return <OrderSent />;
    }
  };

  const handleNext = () => {
    if (activeStep === 2) {
      setIsLoading(true);
      setTimeout(() => {
        handleReset();
        toastSuccessHelper('Order saved');
        sendOrder({
          name: `test${Math.floor(Math.random() * 10000)}`,
          currency_id: currency.value,
          order_size_type_id: order.value,
          order_size: Number(valuation),
          valuation: Number(valuationPercent),
          sent: true
        });
        // setActiveStep((prevActiveStep) => prevActiveStep + 1);
        setIsLoading(false);
      }, 2500);
      // setActiveStep((prevActiveStep) => prevActiveStep + 1);
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  };

  const handleSave = () => {
    setIsLoading(true);
    setTimeout(() => {
      handleReset();
      toastSuccessHelper('Order saved');
      saveOrder({
        name: `test${Math.floor(Math.random() * 10000)}`,
        currency_id: currency.value,
        order_size_type_id: order.value,
        order_size: orderValue,
        valuation,
        sent: false
      });
      // setActiveStep((prevActiveStep) => prevActiveStep + 1);
      setIsLoading(false);
    }, 2500);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  return (
    <div className={classes.root}>
      <Stepper
        alternativeLabel
        activeStep={activeStep}
        classes={{
          root: classes.stepper
        }}
        connector={<ColorlibConnector />}>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel
              classes={{
                root: classes.stepperLabel
              }}
              StepIconComponent={ColorlibStepIcon}>
              {label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
      {renderStep(activeStep)}
      <div>
        {activeStep === steps.length ? (
          <div className={classes.buttonContainer}>
            <Typography className={classes.instructions}>
              All steps completed - you&apos;re finished
            </Typography>
            <Button
              variant="outlined"
              className={classes.button}
              onClick={handleReset}>
              Reset
            </Button>
          </div>
        ) : (
          <div className={classes.buttonContainer}>
            <div>
              <Button
                variant="outlined"
                className={classes.button}
                disabled={activeStep === 0 || loading}
                onClick={handleBack}>
                Back
              </Button>
              <Button
                disabled={!currency || !order || loading}
                className={classes.button}
                color="primary"
                variant="contained"
                onClick={handleNext}>
                {activeStep === steps.length - 1 ? 'Send' : 'Next'}
              </Button>
              {activeStep === 2 && (
                <Button
                  disabled={loading}
                  className={classes.button}
                  color="primary"
                  variant="contained"
                  onClick={handleSave}>
                  Save
                </Button>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

StepperComponent.propTypes = {
  saveOrder: PropTypes.func.isRequired,
  sendOrder: PropTypes.func.isRequired
};

export default StepperComponent;
